import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { required } from 'redux-form-validators';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { DefaultButton, ReduxTextField } from 'common/components';
import { withTheme } from 'common/styling/theme';
import { confirmPaymentsV2Operation } from 'client/payments/_redux';

import { staticStyles, getDynamicStyles } from './style';

const PaymentsConfirmOtpForm = ({
  onClose,
  theme,
  paymentId,
  handleSubmit,
  confirmPaymentsV2Operation,
  dispatch,
  submitting,
}) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  const submit = handleSubmit(values => confirmPaymentsV2Operation({ ...values, id: paymentId }, dispatch));

  return (
    <div className="PaymentsConfirmOtpForm__wrapper">
      <form className="PaymentsConfirmOtpForm" onSubmit={submit}>
        <div className="PaymentsConfirmOtpForm__message-block">
          <FormattedMessage id="authPleaseEnterVerificationCode">
            {txt => <p className="PaymentsConfirmOtpForm__message-enter-code">{txt}:</p>}
          </FormattedMessage>
          <div className="PaymentsConfirmOtpForm__code-field">
            <Field
              component={ReduxTextField}
              name="otp"
              textId="authCode"
              disabled={submitting}
              validate={[required()]}
            />
            <DefaultButton
              type="submit"
              textId="justVerify"
              filled
              className="PaymentsConfirmOtpForm__submit-button"
              disabled={submitting}
            />
          </div>
        </div>
      </form>
      <DefaultButton textId="justCancel" className="PaymentsConfirmOtpForm__cancel-button" onClick={onClose} />
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

PaymentsConfirmOtpForm.propTypes = {
  paymentId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  confirmPaymentsV2Operation: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  theme: PropTypes.object,
};

PaymentsConfirmOtpForm.defaultProps = {
  theme: {},
};

export default compose(
  withTheme(),
  connect(null, {
    confirmPaymentsV2Operation: payload => confirmPaymentsV2Operation.request(payload),
  }),
  reduxForm({
    form: 'PaymentsConfirmOtpForm',
    onSubmitSuccess: (result, dispatch, { onClose }) => {
      onClose();
    },
  })
)(PaymentsConfirmOtpForm);
